import { Component } from "@angular/core";

@Component({
	selector: "caass-report",
	templateUrl: "./report.component.html",
})
export class ReportComponent {}
